import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-hourglass-empty",
  templateUrl: "./med-icon-hourglass-empty.component.html",
})
export class MedIconHourglassEmptyComponent extends SvgMixinComponent {}
